(function(){
  var marker = 'v2-lre-keyboard-dedupe-sync';
  if (window.__nestVariantBundlePaintExperiment === marker) return;
  window.__nestVariantBundlePaintExperiment = marker;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function(){
    if (!window.jQuery) return;

    var $ = window.jQuery;
    var originalHide = $.fn.__nestLreOriginalHide || $.fn.hide;
    var originalCss = $.fn.__nestLreOriginalCss || $.fn.css;
    var syncTimer = null;
    var observer = null;

    $.fn.__nestLreOriginalHide = originalHide;
    $.fn.__nestLreOriginalCss = originalCss;

    function isLreOnlySet(set) {
      return set && set.length && set.filter('.comfort-bundle-lre').length === set.length;
    }

    function getSelectedSize() {
      var select = document.querySelector('#product-detail-size-chooser-0');
      if (select && select.value) return select.value.trim();

      var styled = document.querySelector('#product-detail-size-chooser-0 + .styledSelect .option-flex > span');
      return styled ? styled.textContent.trim() : '';
    }

    function syncLreBundle() {
      var size = getSelectedSize();
      if (!size) return;

      var rows = Array.prototype.slice.call(document.querySelectorAll('.comfort-bundle-lre'));
      if (!rows.length) return;

      var matched = rows.find(function(row){
        return (row.getAttribute('data-size') || '').trim() === size;
      });
      if (!matched) return;

      document.documentElement.classList.add('nest-lre-js-synced');

      rows.forEach(function(row){
        row.style.display = row === matched ? 'flex' : 'none';
        row.setAttribute('data-nest-lre-sync', marker);
      });
    }

    function scheduleSync() {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncLreBundle, 0);
      window.setTimeout(syncLreBundle, 80);
      window.setTimeout(syncLreBundle, 180);
    }

    $.fn.hide = function(){
      if (isLreOnlySet(this)) {
        scheduleSync();
        return this;
      }
      return originalHide.apply(this, arguments);
    };

    $.fn.css = function(prop) {
      var result = originalCss.apply(this, arguments);
      if (isLreOnlySet(this)) {
        var touchesDisplay = prop === 'display' || (
          prop &&
          typeof prop === 'object' &&
          Object.prototype.hasOwnProperty.call(prop, 'display')
        );
        if (touchesDisplay) scheduleSync();
      }
      return result;
    };

    ['change', 'click', 'keydown', 'keyup', 'focusout'].forEach(function(type){
      document.addEventListener(type, function(event){
        if (!event.target || !event.target.closest) return;
        if (event.target.id === 'product-detail-size-chooser-0' ||
            event.target.closest('#product-detail-size-chooser-0 + .styledSelect, #product-detail-size-chooser-0 + .styledSelect + ul.options li.option-flex')) {
          scheduleSync();
        }
      }, true);
    });

    var root = document.querySelector('.comfort-bundle-products') ||
      document.querySelector('.comfort-bundle') ||
      document.body;

    if (window.MutationObserver && root) {
      observer = new MutationObserver(function(mutations){
        var touchedLre = mutations.some(function(mutation){
          return mutation.target &&
            mutation.target.classList &&
            mutation.target.classList.contains('comfort-bundle-lre');
        });
        if (touchedLre) scheduleSync();
      });
      observer.observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    window.__nestLreBundlePaintExperiment = {
      marker: marker,
      sync: syncLreBundle,
      remove: function(){
        if ($.fn.__nestLreOriginalHide) $.fn.hide = $.fn.__nestLreOriginalHide;
        if ($.fn.__nestLreOriginalCss) $.fn.css = $.fn.__nestLreOriginalCss;
        if (observer) observer.disconnect();
        document.documentElement.classList.remove('nest-lre-js-synced');
        delete window.__nestLreBundlePaintExperiment;
        delete window.__nestVariantBundlePaintExperiment;
      }
    };

    syncLreBundle();
    window.setTimeout(syncLreBundle, 200);
    window.setTimeout(syncLreBundle, 800);
  });
})();
